module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body column centered-start banco-precos-main-container"
  }, [_c('div', {
    ref: "topo",
    staticClass: "row-flex centered-start banco-precos-header-container"
  }, [_c('i', {
    staticClass: "fa fa-cubes"
  }), _vm._v(" "), _c('b', [_vm._v("BUSCA PREÇO")])]), _vm._v(" "), _c('div', {
    staticClass: "column centered-start banco-precos-filtro-container"
  }, [_c('div', {
    staticClass: "column centered-start banco-precos-base-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start w-100 gap-5"
  }, [_c('div', {
    staticClass: "form-item-container"
  }, [_vm._m(1), _vm._v(" "), _c('multiselect', {
    staticClass: "select-container-sm",
    attrs: {
      "options": _vm.selectOptions.tipoItem,
      "searchable": false,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Selecione o Tipo de Item"
    },
    on: {
      "input": function($event) {
        return _vm.clearClassificadores()
      }
    },
    model: {
      value: (_vm.selecaoTipoItens),
      callback: function($$v) {
        _vm.selecaoTipoItens = $$v
      },
      expression: "selecaoTipoItens"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-container"
  }, [_vm._m(2), _vm._v(" "), _c('multiselect', {
    staticClass: "select-container-sm",
    attrs: {
      "options": _vm.selectOptions.uf,
      "searchable": false,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Selecione o UF"
    },
    on: {
      "input": function($event) {
        return _vm.clearClassificadores()
      }
    },
    model: {
      value: (_vm.selecaoUfs),
      callback: function($$v) {
        _vm.selecaoUfs = $$v
      },
      expression: "selecaoUfs"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-start w-100 gap-5 banco-precos-aparecer banco-precos-aviso-filtro"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.abrirFiltrosAvancados),
      expression: "abrirFiltrosAvancados"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.abrirFiltrosAvancados) ? _vm._i(_vm.abrirFiltrosAvancados, null) > -1 : (_vm.abrirFiltrosAvancados)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.abrirFiltrosAvancados,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.abrirFiltrosAvancados = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.abrirFiltrosAvancados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.abrirFiltrosAvancados = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.abrirFiltrosAvancados) ? _c('div', {
    staticClass: "row-flex centered-start banco-precos-aparecer banco-precos-filtros-avancados-container"
  }, [_c('div', {
    staticClass: "form-item-container"
  }, [_vm._m(4), _vm._v(" "), _c('money', {
    staticClass: "form-control",
    model: {
      value: (_vm.valorMaximo),
      callback: function($$v) {
        _vm.valorMaximo = $$v
      },
      expression: "valorMaximo"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column centered-start banco-precos-refinadores-container"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-start w-100 gap-5 banco-precos-aparecer banco-precos-aviso"
  }, [_c('label', [_c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Filtros específicos"
    }
  }), _vm._v(" Pesquisar por categorizadores ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.procuraCategorizadores),
      expression: "procuraCategorizadores"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.procuraCategorizadores) ? _vm._i(_vm.procuraCategorizadores, null) > -1 : (_vm.procuraCategorizadores)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.procuraCategorizadores,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.procuraCategorizadores = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.procuraCategorizadores = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.procuraCategorizadores = $$c
        }
      }, function($event) {
        return _vm.handleCategorizadores()
      }]
    }
  })]), _vm._v(" "), (!_vm.procuraIndividual) ? _c('div', {
    staticClass: "column centered-start w-100 gap-5"
  }, [_c('div', {
    staticClass: "row-flex centered-start w-100 gap-5 banco-precos-aparecer"
  }, [_c('div', {
    staticClass: "form-item-container"
  }, [_c('label', [_vm._v("I - Categoria (Seleção Múltipla):")]), _vm._v(" "), _c('multiselect', {
    staticClass: "select-container-md",
    attrs: {
      "options": _vm.selectOptions.categoria,
      "searchable": true,
      "multiple": true,
      "close-on-select": true,
      "show-labels": true,
      "hide-selected": true,
      "max": 5,
      "loading": _vm.loading.categoria,
      "placeholder": "Pesquisar, a categoria geral do item desejado (Ex: MATERIAL, MEDICAMENTO, MAQUINAS, INFORMATICA, etc.)"
    },
    on: {
      "search-change": function($event) {
        return _vm.debounceFiltro($event, 'categoria')
      },
      "input": function($event) {
        return _vm.consultarGrupoItem()
      }
    },
    scopedSlots: _vm._u([{
      key: "maxElements",
      fn: function() {
        return [_vm._v("\n             Número máximo de elementos selecionados. Primeiro remova algum para adicionar novamente.\n           ")]
      },
      proxy: true
    }, {
      key: "noOptions",
      fn: function() {
        return [_vm._v("\n             Lista Vazia, utilize os controles para pesquisar ou digite.\n           ")]
      },
      proxy: true
    }, {
      key: "noResult",
      fn: function() {
        return [_vm._v("\n             Termo não encontrado, tente outro termo ou utilize os controladores para refazer a pesquisa.\n           ")]
      },
      proxy: true
    }], null, false, 1769692805),
    model: {
      value: (_vm.selecaoCategoria),
      callback: function($$v) {
        _vm.selecaoCategoria = $$v
      },
      expression: "selecaoCategoria"
    }
  })], 1)]), _vm._v(" "), (_vm.selectOptions.grupo.length > 0) ? _c('div', {
    staticClass: "row-flex centered-start w-100 gap-5 banco-precos-aparecer"
  }, [_c('div', {
    staticClass: "form-item-container"
  }, [_c('label', [_vm._v("II - Grupo (Seleção Múltipla):")]), _vm._v(" "), _c('multiselect', {
    staticClass: "select-container-md",
    attrs: {
      "options": _vm.selectOptions.grupo,
      "searchable": true,
      "multiple": true,
      "close-on-select": true,
      "show-labels": true,
      "hide-selected": true,
      "max": 5,
      "loading": _vm.loading.grupo,
      "placeholder": "O grupo no qual o item pertence (Ex: CONSTRUCAO, HOSPITALAR, INDUSTRIAL, ACESSORIOS, etc.)"
    },
    on: {
      "search-change": function($event) {
        return _vm.debounceFiltro($event, 'grupo')
      },
      "input": function($event) {
        return _vm.consultarClassificacaoItem()
      }
    },
    scopedSlots: _vm._u([{
      key: "maxElements",
      fn: function() {
        return [_vm._v("\n             Número máximo de elementos selecionados. Primeiro remova algum para adicionar novamente.\n           ")]
      },
      proxy: true
    }, {
      key: "noOptions",
      fn: function() {
        return [_vm._v("\n             Lista Vazia, utilize os controles para pesquisar ou digite.\n           ")]
      },
      proxy: true
    }, {
      key: "noResult",
      fn: function() {
        return [_vm._v("\n             Termo não encontrado, tente outro termo ou utilize os controladores para refazer a pesquisa.\n           ")]
      },
      proxy: true
    }], null, false, 1769692805),
    model: {
      value: (_vm.selecaoGrupos),
      callback: function($$v) {
        _vm.selecaoGrupos = $$v
      },
      expression: "selecaoGrupos"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectOptions.classificacao.length > 0) ? _c('div', {
    staticClass: "row-flex centered-start w-100 gap-5 banco-precos-aparecer"
  }, [_c('div', {
    staticClass: "form-item-container"
  }, [_c('label', [_vm._v("III - Classificação (Seleção Múltipla):")]), _vm._v(" "), _c('multiselect', {
    staticClass: "select-container-md",
    attrs: {
      "options": _vm.selectOptions.classificacao,
      "searchable": true,
      "multiple": true,
      "close-on-select": true,
      "show-labels": true,
      "hide-selected": true,
      "max": 5,
      "loading": _vm.loading.classificacao,
      "placeholder": "Classificação mais específica do item."
    },
    on: {
      "search-change": function($event) {
        return _vm.debounceFiltro($event, 'classificacao')
      },
      "input": function($event) {
        return _vm.consultarItens()
      }
    },
    scopedSlots: _vm._u([{
      key: "maxElements",
      fn: function() {
        return [_vm._v("\n             Número máximo de elementos selecionado. Primeiro remova algum para adicionar novamente.\n           ")]
      },
      proxy: true
    }, {
      key: "noOptions",
      fn: function() {
        return [_vm._v("\n             Lista Vazia, utilize os controles para pesquisar ou digite.\n           ")]
      },
      proxy: true
    }, {
      key: "noResult",
      fn: function() {
        return [_vm._v("\n             Termo não encontrado, tente outro termo ou utilize os controladores para refazer a pesquisa.\n           ")]
      },
      proxy: true
    }], null, false, 3695275958),
    model: {
      value: (_vm.selecaoClassificacoes),
      callback: function($$v) {
        _vm.selecaoClassificacoes = $$v
      },
      expression: "selecaoClassificacoes"
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selecaoCategoria.length > 0 || _vm.procuraIndividual) ? _c('div', {
    staticClass: "column centered-start banco-precos-item-container banco-precos-aparecer"
  }, [_c('div', {
    staticClass: "row-flex centered-start w-100 gap-5"
  }, [_c('div', {
    staticClass: "form-item-container"
  }, [_vm._m(6), _vm._v(" "), _c('multiselect', {
    staticClass: "select-container-xl",
    attrs: {
      "options": _vm.selectOptions.item,
      "loading": _vm.loading.item,
      "searchable": true,
      "multiple": true,
      "close-on-select": true,
      "show-labels": true,
      "hide-selected": true,
      "max": 5,
      "placeholder": "Pesquisar o Item"
    },
    on: {
      "search-change": function($event) {
        return _vm.debounceFiltro($event, 'item')
      }
    },
    scopedSlots: _vm._u([{
      key: "maxElements",
      fn: function() {
        return [_vm._v("\n             Número máximo de elementos selecionado. Primeiro remova algum para adicionar novamente.\n           ")]
      },
      proxy: true
    }, {
      key: "noOptions",
      fn: function() {
        return [_vm._v("\n             Lista Vazia, utilize os controles para pesquisar ou digite.\n           ")]
      },
      proxy: true
    }, {
      key: "noResult",
      fn: function() {
        return [_vm._v("\n             Termo não encontrado, tente outro termo ou utilize os controladores para refazer a pesquisa.\n           ")]
      },
      proxy: true
    }], null, false, 3695275958),
    model: {
      value: (_vm.selecaoItems),
      callback: function($$v) {
        _vm.selecaoItems = $$v
      },
      expression: "selecaoItems"
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-end w-100 gap-5"
  }, [(_vm.selecaoItems.length > 0 || (_vm.selecaoCategoria.length > 0)) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.consultarItensLicitacao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-database",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Pesquisar ")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearTipoSelection()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Limpar Filtros ")])], 1)]), _vm._v(" "), (_vm.resultadoItems.length > 0) ? _c('div', {
    staticClass: "column all-centered w-100 banco-precos-inferior-container"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row-flex start-centered w-100 gap-5"
  }, [_c('div', {
    staticClass: "column centered-start banco-precos-caracteristicas-container"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "column centered-start banco-precos-titulo-container"
  }, [(_vm.mostrarFiltroDetalhe) ? _c('div', {
    staticClass: "column all-start banco-precos-filtro-caracteristica-container banco-precos-aparecer"
  }, [_c('div', {
    staticClass: "row-flex all-start form-item-container gap-10"
  }, [_c('label', [_vm._v("Tipo de Filtro: ")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-start"
  }, [_c('span', {
    staticClass: "row-flex all-centered span-filtro"
  }, [_c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "As características selecionadas serão"
    }
  }), _vm._v("Inclusivo ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoFiltroCaracteristica),
      expression: "tipoFiltroCaracteristica"
    }],
    attrs: {
      "type": "radio",
      "value": "INCLUSIVO"
    },
    domProps: {
      "checked": _vm._q(_vm.tipoFiltroCaracteristica, "INCLUSIVO")
    },
    on: {
      "change": function($event) {
        _vm.tipoFiltroCaracteristica = "INCLUSIVO"
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-start"
  }, [_c('span', {
    staticClass: "row-flex all-centered span-filtro"
  }, [_c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Os resultados podem ser genéricos"
    }
  }), _vm._v("Exclusivo ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoFiltroCaracteristica),
      expression: "tipoFiltroCaracteristica"
    }],
    attrs: {
      "type": "radio",
      "value": "EXCLUSIVO"
    },
    domProps: {
      "checked": _vm._q(_vm.tipoFiltroCaracteristica, "EXCLUSIVO")
    },
    on: {
      "change": function($event) {
        _vm.tipoFiltroCaracteristica = "EXCLUSIVO"
      }
    }
  })])]), _vm._v(" "), _vm._m(9)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "banco-precos-caracteristicas-items-container"
  }, _vm._l((_vm.filtroItensCaracteristica), function(items, key) {
    return _c('div', {
      key: key,
      staticClass: "column all-start w-100"
    }, [_c('div', {
      staticClass: "row-flex centered-between banco-precos-item-tipo-caracteristica",
      class: _vm.isSelected(key) ? 'banco-precos-item-tipo-caracteristica-selecionada' : '',
      on: {
        "click": function($event) {
          return _vm.toggleVisibility(key)
        }
      }
    }, [_c('div', {
      on: {
        "click": [function($event) {
          $event.stopPropagation();
        }, function($event) {
          return _vm.toggleTodasCaracteristicas(key)
        }]
      }
    }, [_c('i', {
      staticClass: "fa fa-power-off",
      class: _vm.isSelected(key) ? 'icon-selected' : 'icon-deselected'
    }), _vm._v(" " + _vm._s(key.replace(/_/g, ' ')) + " (" + _vm._s(items.length) + ")\n             ")]), _vm._v(" "), _c('i', {
      staticClass: "fa",
      class: _vm.isVisible(key) ? 'fa-caret-down' : 'fa-caret-left'
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isVisible(key)),
        expression: "isVisible(key)"
      }],
      staticClass: "column banco-precos-selecao-caracteristicas-container"
    }, _vm._l((items), function(item, index) {
      return _c('div', {
        key: (key + "-" + (item.caracteristica) + "-" + index),
        staticClass: "row-flex centered-end banco-precos-caracteristica",
        class: item.selecionado ? 'banco-precos-caracteristica-selecionada' : '',
        on: {
          "click": function($event) {
            return _vm.atualizarSelecaoCaracteristicas(key, item, index)
          }
        }
      }, [_vm._v("\n               " + _vm._s(item.caracteristica) + " "), _c('i', {
        staticClass: "fa fa-power-off",
        class: item.selecionado ? 'icon-selected' : 'icon-deselected'
      })])
    }), 0)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "column centered-start banco-precos-resultados-container"
  }, [_c('div', {
    staticClass: "column centered-start banco-precos-titulo-container"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-between banco-precos-subtitulo"
  }, [_vm._v("\n           Confira os (" + _vm._s(_vm.table.items.length) + ") itens encontrados a partir dos filtros\n           "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetarItensTabela()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Limpar Seleção ")])], 1)]), _vm._v(" "), _c('b-container', {
    ref: "itemsEncontrados",
    staticClass: "column centered-start w-100 gap-10 banco-precos-table-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    staticClass: "banco-precos-tabela",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('g-button-ujarak', {
          attrs: {
            "color": "primary"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.detalharItem(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye",
          attrs: {
            "aria-hidden": "true"
          }
        })])]
      }
    }, {
      key: "descricao_item",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row-flex all-start banco-precos-table-descricao-container"
        }, [_c('div', {
          staticClass: "banco-precos-table-descricao",
          attrs: {
            "title": row.value
          }
        }, [_vm._v("\n                   [" + _vm._s(row.item.id) + "] " + _vm._s(row.value) + "\n                 ")])])]
      }
    }, {
      key: "valor_item",
      fn: function(row) {
        return [_vm._v("\n                 " + _vm._s(_vm._f("real")(row.value)) + "\n             ")]
      }
    }, {
      key: "selecionado",
      fn: function(row) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (row.item.selecionado),
            expression: "row.item.selecionado"
          }],
          key: row.item.id,
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(row.item.selecionado) ? _vm._i(row.item.selecionado, null) > -1 : (row.item.selecionado)
          },
          on: {
            "change": [function($event) {
              var $$a = row.item.selecionado,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(row.item, "selecionado", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(row.item, "selecionado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(row.item, "selecionado", $$c)
              }
            }, function($event) {
              return _vm.verificaExclusaoManual(row.item)
            }]
          }
        })]
      }
    }, {
      key: "data_resultado_licitacao",
      fn: function(row) {
        return [_vm._v("\n                 " + _vm._s(row.value !== '' ? _vm.moment.utc(row.value).format('MM/YYYY') : '-') + "\n             ")]
      }
    }, {
      key: "sigla_uf",
      fn: function(row) {
        return [_vm._v("\n                 " + _vm._s(row.value !== '0' ? row.value : '-') + "\n             ")]
      }
    }], null, false, 2871997631)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "w-100"
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1), _vm._v(" "), (_vm.abrirJustificativa) ? _c('div', {
    staticClass: "column all-centered banco-precos-justificativa-modal",
    on: {
      "click": function($event) {
        return _vm.cancelaRemocaoManual(_vm.itemJustificativa)
      }
    }
  }, [_c('div', {
    staticClass: "column all-centered banco-precos-justificativa-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "form-item-container"
  }, [_c('label', [_c('i', {
    staticClass: "fa fa-cube"
  }), _vm._v(" Selecione o Motivo para desconsiderar o item:")]), _vm._v(" "), _c('multiselect', {
    staticClass: "select-container-xl",
    attrs: {
      "options": _vm.selectJustificativa,
      "multiple": false,
      "close-on-select": true,
      "placeholder": "Selecione o Motivo"
    },
    model: {
      value: (_vm.selecaoJustificativa),
      callback: function($$v) {
        _vm.selecaoJustificativa = $$v
      },
      expression: "selecaoJustificativa"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-end w-100 gap-5"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.gravaRemocaoManual(_vm.itemJustificativa)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Confirmar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "error"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelaRemocaoManual(_vm.itemJustificativa)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar ")])], 1)])]) : _vm._e()], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.loading.show) ? _c('div', {
    ref: "loadingItems",
    staticClass: "column all-centered w-100 banco-precos-inferior-container"
  }, [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.abrirDetalheItem) ? _c('div', {
    ref: "detalhamentoContainer",
    staticClass: "column all-centered banco-precos-detalhamento-item"
  }, [_c('detalheItemLicitacao', {
    attrs: {
      "itemLicitacao": _vm.itemDetalheSelecionado,
      "toggleDetalhe": _vm.toggleDetalhe
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-end w-100 gap-5"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.gravarResultado()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Utilizar Resultado ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "error"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleBancoPrecos(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex centered-between banco-precos-titulo"
  }, [_c('div', {
    staticClass: "row-flex all-centered gap-5"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" "), _c('label', [_vm._v("Filtros (Comece por aqui)")])]), _vm._v(" "), _c('div', {
    staticClass: "column all-centered"
  }, [_c('i', {
    staticClass: "fa fa-caret-up"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f-required"
  }, [_c('i', {
    staticClass: "fa fa-cubes"
  }), _vm._v(" Tipo de Item:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-map-o"
  }), _vm._v(" UF (opcional):")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" Filtros Avançados ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-hand-o-up"
  }), _vm._v(" Valor máximo:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex centered-between banco-precos-titulo"
  }, [_c('div', {
    staticClass: "row-flex all-centered gap-5"
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" "), _c('label', [_vm._v("Classificadores (Utilize as opções abaixo para afunilar sua pesquisa, selecione até 5 tags de cada tipo)")])]), _vm._v(" "), _c('div', {
    staticClass: "column all-centered"
  }, [_c('i', {
    staticClass: "fa fa-caret-up"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-cube"
  }), _vm._v(" Item (Seleção Múltipla):")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex centered-start banco-precos-titulo"
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _vm._v(" "), _c('label', [_vm._v("Resultados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column centered-start banco-precos-titulo-container"
  }, [_c('div', {
    staticClass: "banco-precos-titulo-resultado"
  }, [_c('i', {
    staticClass: "fa fa-barcode"
  }), _vm._v(" Explorador de caracteristicas\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "banco-precos-subtitulo"
  }, [_vm._v("\n           Selecione uma ou mais características para refinar sua pesquisa\n         ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex all-centered form-item-container gap-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquise uma caracteristica aqui."
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "banco-precos-filtro-carecteristica-button",
    attrs: {
      "title": "Limpar Filtro"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banco-precos-titulo-resultado"
  }, [_c('i', {
    staticClass: "fa fa-feed"
  }), _vm._v(" Itens encontrados\n         ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex all-centered banco-precos-titulo"
  }, [_vm._v("\n     Pesquisando Items... \n     "), _c('i', {
    staticClass: "fa fa-hourglass-end banco-precos-spin",
    staticStyle: {
      "font-size": "30px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d79cb9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/comparativoPrecos/bancoPrecos.vue
// module id = 1874
// module chunks = 1